// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.FcInspection = function FcInspection(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1",
      "viewBox": "0 0 48 48",
      "enableBackground": "new 0 0 48 48"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "#455A64",
        "d": "M36,4H26c0,1.1-0.9,2-2,2s-2-0.9-2-2H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8 C40,5.8,38.2,4,36,4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "#fff",
        "d": "M36,41H12c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1v32C37,40.6,36.6,41,36,41z"
      }
    }, {
      "tag": "g",
      "attr": {
        "fill": "#90A4AE"
      },
      "child": [{
        "tag": "path",
        "attr": {
          "d": "M26,4c0,1.1-0.9,2-2,2s-2-0.9-2-2h-7v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4H26z"
        }
      }, {
        "tag": "path",
        "attr": {
          "d": "M24,0c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S26.2,0,24,0z M24,6c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S25.1,6,24,6z"
        }
      }]
    }, {
      "tag": "polygon",
      "attr": {
        "fill": "#4CAF50",
        "points": "30.6,18.6 21.6,27.6 17.4,23.3 14.9,25.8 21.7,32.5 33.1,21.1"
      }
    }]
  })(props);
};